module.exports = __webpack_public_path__ + "static/media/clareador-facial.f9ab6892.jpg";